import React from 'react';
import { Link } from 'react-router-dom';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_wix-redesign-2/artifacts/q82hbmsf_Gyan%20Dhara%20logo.webp';

export default function Logo({ compact = false }) {
  return (
    <Link to="/" className="flex items-center gap-2 select-none group" data-testid="brand-logo">
      <span className="relative inline-flex h-10 w-10 items-center justify-center overflow-hidden rounded-xl transition-transform duration-300 group-hover:rotate-3">
        <img src={LOGO_URL} alt="Gyan Dhara" className="h-full w-full object-contain" />
      </span>
      {!compact && (
        <span className="leading-tight font-bold text-[13px] tracking-wide">
          <span className="block text-navy">GYAN</span>
          <span className="block text-purple">DHARA</span>
        </span>
      )}
    </Link>
  );
}

